import { Component } from 'react';
import { Link as RouterLink, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types'        ;
import logo from '../../assets/images/logo_new.png';
import { StepOne, StepTwo } from './components';

import {
  Grid,
  Button,
  Typography,
  AppBar,
  Toolbar,
  Box,
  InputBase,
  IconButton
} from '@mui/material';

import { SearchOutlined, ArrowBackOutlined } from '@mui/icons-material';

class SignUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      div1: true,
      div2: false
    };
  }

  stepOne() {
    this.setState({ div1: true, div2: false });
  }

  stepTwo() {
    this.setState({ div1: false, div2: true });
  }

  render() {
    return (
      <Box sx={{ mb: 5 }}>
        <AppBar
          position="relative"
          sx={{
            background: 'transparent',
            boxShadow: 'none',
            py: 2.5
          }}>
          <Toolbar sx={{ p: '0 !important' }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                flex: 1,
                px: 2
              }}>
              <RouterLink to="/">
                <Box
                  component="img"
                  alt="Logo"
                  src={logo}
                  sx={{
                    width: 175,
                    display: 'block',
                    '@media (max-width:600px)': {
                      width: 125
                    }
                  }}
                />
              </RouterLink>

              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Box
                  sx={{
                    border: '1px solid #ccc',
                    height: 42,
                    background: '#fff',
                    display: { xs: 'none', sm: 'flex' },
                    position: 'relative',
                    mr: 1.5,
                    width: 400
                  }}>
                  <InputBase
                    placeholder="Search clinic"
                    sx={{
                      px: 1.8,
                      fontSize: 16,
                      width: '100%',
                      color: '#333',
                      '& input::placeholder': {
                        color: '#9E9E9E',
                        opacity: 1
                      }
                    }}
                  />

                  <IconButton
                    component={RouterLink}
                    to="/search"
                    sx={{
                      backgroundColor: '#3397F3',
                      borderRadius: 0,
                      width: 44,
                      color: '#fff',
                      '&:hover': {
                        backgroundColor: '#2B86DB'
                      }
                    }}>
                    <SearchOutlined />
                  </IconButton>
                </Box>

                <Button
                  variant="contained"
                  color='primary'
                  component={RouterLink}
                  to="/sign-in"
                 >
                  Login
                </Button>
              </Box>
            </Box>
          </Toolbar>
        </AppBar>

        <Grid container>
          <Grid size={{ xs: 12 }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: {
                  xs: 'center', // down('md') and down('sm')
                  md: 'flex-start'
                },
                flexDirection: 'column',
                backgroundColor: '#FFFFFF',
                boxShadow: '0px 0px 25px rgba(47, 47, 47, 0.5)',
                p: {
                  xs: '20px',
                  sm: '20px',
                  md: '30px 40px 20px 40px'
                },
                transition: 'display 2s',
                width: '100%',
                maxWidth: '1200px',
                mx: 'auto'
              }}>
              <Typography variant="title">EHR Registration</Typography>

              {this.state.div1 && (
                <Box>
                  <StepOne />

                  <Grid
                    container
                    sx={{
                      mt: 3,
                      justifyContent: 'flex-end'
                    }}>
                    <Button
                      onClick={() => this.stepTwo()}
                      variant="contained"
                      color='secondary'
                      >
                      Next
                    </Button>
                  </Grid>
                </Box>
              )}

              {this.state.div2 && (
                <Box>
                  <StepTwo />

                  <Grid
                    container
                    sx={{
                      mt: 3,
                      justifyContent: 'space-between'
                    }}>
                    <Button
                      onClick={() => this.stepOne()}
                      variant="outlined"
                      color='primary'

                     >
                      <ArrowBackOutlined />
                    </Button>

                    <Button
                      component={RouterLink}
                      to="/terms"
                      variant="contained"
                      color='secondary'
                     >
                      Register
                    </Button>
                  </Grid>
                </Box>
              )}
            </Box>
          </Grid>
        </Grid>
      </Box>
    );
  }
}

SignUp.propTypes = {
  history: PropTypes.object
};

export default withRouter(SignUp);
